// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__2dfE7","alert":"SettungsInbox_alert__1hAxo"};